import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';

const StatBar = ({ label, value }) => {
	const [displayValue, setDisplayValue] = useState(0);
	const hasCounted = useRef(false);

	const runCountUp = () => {
		if (hasCounted.current) return;
		hasCounted.current = true;
		let current = 0;
		const step = () => {
			current += Math.max(1, Math.round(value / 30));
			if (current >= value) {
				setDisplayValue(value);
				return;
			}
			setDisplayValue(current);
			requestAnimationFrame(step);
		};
		requestAnimationFrame(step);
	};

	return (
		<div>
			<div className="flex justify-between mb-1 font-mono text-xs uppercase tracking-wider">
				<span className="text-gray-300">{label}</span>
				<span className="text-gold">{displayValue}</span>
			</div>
			<div className="w-full h-2.5 bg-panel2 rounded-sm overflow-hidden border border-gold/20">
				<motion.div
					className="relative h-full overflow-hidden bg-gradient-to-r from-rpgblue to-gold"
					initial={{ width: 0 }}
					whileInView={{ width: `${value}%` }}
					viewport={{ once: true, amount: 0.6 }}
					transition={{ duration: 1, ease: 'easeOut' }}
					onViewportEnter={runCountUp}
				>
					<div
						className="absolute inset-0 opacity-30 animate-[shimmer-slide_1s_linear_infinite]"
						style={{
							backgroundImage:
								'repeating-linear-gradient(45deg, rgba(255,255,255,0.6) 0, rgba(255,255,255,0.6) 4px, transparent 4px, transparent 10px)',
						}}
						aria-hidden="true"
					/>
				</motion.div>
			</div>
		</div>
	);
};

export default StatBar;
